import { useSelector } from 'react-redux';
import { getOverviewsForUrl } from '../../store/analysis/selectors';

export function useGetOverviewsForUrl(url: string) {
	const overviews = useSelector((state) => getOverviewsForUrl(state, url));
	return overviews;
}
